(function () {
    'use strict';

    var toggle = document.querySelector('[data-az-menu-toggle]');
    var nav = document.getElementById('az-head-nav');

    if (!toggle || !nav) {
        return;
    }

    var openIcon = toggle.querySelector('[data-az-menu-open]');
    var closeIcon = toggle.querySelector('[data-az-menu-close]');
    var isOpen = false;

    function focusableIn(container) {
        return Array.prototype.slice.call(
            container.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])')
        ).filter(function (el) {
            return el.offsetParent !== null;
        });
    }

    function openMenu() {
        isOpen = true;
        document.documentElement.classList.add('has-menu-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (openIcon) { openIcon.hidden = true; }
        if (closeIcon) { closeIcon.hidden = false; }

        var focusable = focusableIn(nav);
        if (focusable.length) {
            focusable[0].focus();
        }

        document.addEventListener('keydown', onKeydown);
    }

    function closeMenu(returnFocus) {
        isOpen = false;
        document.documentElement.classList.remove('has-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (openIcon) { openIcon.hidden = false; }
        if (closeIcon) { closeIcon.hidden = true; }

        document.removeEventListener('keydown', onKeydown);

        if (returnFocus) {
            toggle.focus();
        }
    }

    function onKeydown(event) {
        if (event.key === 'Escape') {
            closeMenu(true);
            return;
        }

        if (event.key === 'Tab') {
            var focusable = focusableIn(nav).concat([toggle]);
            var first = focusable[0];
            var last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }

    toggle.addEventListener('click', function () {
        if (isOpen) {
            closeMenu(false);
        } else {
            openMenu();
        }
    });

    // Any link chosen in the open panel closes it. For links to other
    // pages the navigation replaces the page anyway, but in-page anchors
    // ("Start here" -> /#start-here) and Portal links (Subscribe, Sign in)
    // keep the same page - without this the panel stayed open over the
    // section the reader just jumped to (2026-10-01). Focus is not sent
    // back to the toggle: the reader asked to go somewhere else.
    nav.addEventListener('click', function (event) {
        if (isOpen && event.target.closest('a[href]')) {
            closeMenu(false);
        }
    });

    // A window resize past the mobile breakpoint should not leave the
    // panel marked open (and unfocusable content hidden) once it is
    // shown inline again by CSS.
    var mq = window.matchMedia('(min-width: 48em)');
    var onBreakpointChange = function (event) {
        if (event.matches && isOpen) {
            closeMenu(false);
        }
    };
    if (mq.addEventListener) {
        mq.addEventListener('change', onBreakpointChange);
    } else if (mq.addListener) {
        mq.addListener(onBreakpointChange);
    }
}());
